import _assertThisInitialized from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { RELAYER_DEFAULT_PROTOCOL as le, RELAYER_EVENTS as F, EXPIRER_EVENTS as pe, Store as U, Core as he } from "@walletconnect/core";
import { pino as de, getDefaultLoggerOptions as ge, generateChildLogger as me, getLoggerContext as we } from "@walletconnect/logger";
import { IEngine as ue, ISignClient as ye } from "@walletconnect/types";
import { TYPE_1 as Se, createDelayedPromise as T, engineEvent as p, getInternalError as c, calcExpiry as _, isValidObject as K, getRequiredNamespacesFromNamespaces as Ie, getSdkError as E, isSessionCompatible as _e, isBrowser as Ee, hashMessage as z, isExpired as P, isValidParams as S, isUndefined as x, isValidRelays as Re, isValidRequiredNamespaces as Ne, isValidNamespaces as Y, isConformingNamespaces as B, isValidString as D, isValidErrorReason as fe, isValidRelay as ve, isValidController as Pe, isValidNamespacesChainId as Q, isValidRequest as qe, isValidNamespacesRequest as Oe, isValidRequestExpiry as Ve, isValidResponse as Te, isValidEvent as xe, isValidNamespacesEvent as De, parseExpirerTarget as Ae, isValidId as Le, getAppMetadata as be } from "@walletconnect/utils";
import Ce, { EventEmitter as Ge } from "events";
import { THIRTY_DAYS as $e, SEVEN_DAYS as W, FIVE_MINUTES as m, ONE_DAY as q, THIRTY_SECONDS as Z } from "@walletconnect/time";
import { isJsonRpcResult as R, isJsonRpcError as N, formatJsonRpcRequest as Me, formatJsonRpcResult as Ue, formatJsonRpcError as Ke, isJsonRpcRequest as ze, isJsonRpcResponse as Ye } from "@walletconnect/jsonrpc-utils";
var j = "wc",
    k = 2,
    J = "client",
    b = "".concat(j, "@").concat(k, ":").concat(J, ":"),
    C = {
  name: J,
  logger: "error",
  controller: !1,
  relayUrl: "wss://relay.walletconnect.com"
},
    je = {
  session_proposal: "session_proposal",
  session_update: "session_update",
  session_extend: "session_extend",
  session_ping: "session_ping",
  session_delete: "session_delete",
  session_expire: "session_expire",
  session_request: "session_request",
  session_request_sent: "session_request_sent",
  session_event: "session_event",
  proposal_expire: "proposal_expire"
},
    ke = {
  database: ":memory:"
},
    Je = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync"
},
    Xe = "history",
    He = "0.3",
    ee = "proposal",
    Fe = $e,
    se = "Proposal expired",
    te = "session",
    A = W,
    ie = "engine",
    O = {
  wc_sessionPropose: {
    req: {
      ttl: m,
      prompt: !0,
      tag: 1100
    },
    res: {
      ttl: m,
      prompt: !1,
      tag: 1101
    }
  },
  wc_sessionSettle: {
    req: {
      ttl: m,
      prompt: !1,
      tag: 1102
    },
    res: {
      ttl: m,
      prompt: !1,
      tag: 1103
    }
  },
  wc_sessionUpdate: {
    req: {
      ttl: q,
      prompt: !1,
      tag: 1104
    },
    res: {
      ttl: q,
      prompt: !1,
      tag: 1105
    }
  },
  wc_sessionExtend: {
    req: {
      ttl: q,
      prompt: !1,
      tag: 1106
    },
    res: {
      ttl: q,
      prompt: !1,
      tag: 1107
    }
  },
  wc_sessionRequest: {
    req: {
      ttl: m,
      prompt: !0,
      tag: 1108
    },
    res: {
      ttl: m,
      prompt: !1,
      tag: 1109
    }
  },
  wc_sessionEvent: {
    req: {
      ttl: m,
      prompt: !0,
      tag: 1110
    },
    res: {
      ttl: m,
      prompt: !1,
      tag: 1111
    }
  },
  wc_sessionDelete: {
    req: {
      ttl: q,
      prompt: !1,
      tag: 1112
    },
    res: {
      ttl: q,
      prompt: !1,
      tag: 1113
    }
  },
  wc_sessionPing: {
    req: {
      ttl: Z,
      prompt: !1,
      tag: 1114
    },
    res: {
      ttl: Z,
      prompt: !1,
      tag: 1115
    }
  }
},
    G = {
  min: m,
  max: W
},
    re = "request",
    ne = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"];

var Be = Object.defineProperty,
    Qe = Object.defineProperties,
    We = Object.getOwnPropertyDescriptors,
    oe = Object.getOwnPropertySymbols,
    Ze = Object.prototype.hasOwnProperty,
    es = Object.prototype.propertyIsEnumerable,
    ae = function ae(d, r, e) {
  return r in d ? Be(d, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : d[r] = e;
},
    w = function w(d, r) {
  for (var e in r || (r = {})) {
    Ze.call(r, e) && ae(d, e, r[e]);
  }

  if (oe) {
    var _iterator = _createForOfIteratorHelper(oe(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        es.call(r, e) && ae(d, e, r[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return d;
},
    X = function X(d, r) {
  return Qe(d, We(r));
};

var ss = /*#__PURE__*/function (_ue) {
  _inherits(ss, _ue);

  var _super = _createSuper(ss);

  function ss(r) {
    var _this;

    _classCallCheck(this, ss);

    _this = _super.call(this, r), _this.name = ie, _this.events = new Ce(), _this.initialized = !1, _this.ignoredPayloadTypes = [Se], _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.initialized;

              if (_context.t0) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return _this.cleanup();

            case 4:
              _this.registerRelayerEvents();

              _this.registerExpirerEvents();

              _this.client.core.pairing.register({
                methods: Object.keys(O)
              });

              _this.initialized = !0;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.connect = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var s, t, i, n, a, o, l, h, I, _yield$_this$client$c, v, y, g, f, _T, u, V, M, _c, _v, L, ce;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.isInitialized();

                s = X(w({}, e), {
                  requiredNamespaces: e.requiredNamespaces || {},
                  optionalNamespaces: e.optionalNamespaces || {}
                });
                _context3.next = 4;
                return _this.isValidConnect(s);

              case 4:
                t = s.pairingTopic, i = s.requiredNamespaces, n = s.optionalNamespaces, a = s.sessionProperties, o = s.relays;
                l = t, I = !1;

                if (!(l && (I = _this.client.core.pairing.pairings.get(l).active), !l || !I)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return _this.client.core.pairing.create();

              case 9:
                _yield$_this$client$c = _context3.sent;
                v = _yield$_this$client$c.topic;
                y = _yield$_this$client$c.uri;
                l = v, h = y;

              case 13:
                _context3.next = 15;
                return _this.client.core.crypto.generateKeyPair();

              case 15:
                g = _context3.sent;
                f = w({
                  requiredNamespaces: i,
                  optionalNamespaces: n,
                  relays: o !== null && o !== void 0 ? o : [{
                    protocol: le
                  }],
                  proposer: {
                    publicKey: g,
                    metadata: _this.client.metadata
                  }
                }, a && {
                  sessionProperties: a
                });
                _T = T(m, se);
                u = _T.reject;
                V = _T.resolve;
                M = _T.done;

                if (!(_this.events.once(p("session_connect"), /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
                    var v, y, H;
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            v = _ref3.error, y = _ref3.session;

                            if (!v) {
                              _context2.next = 5;
                              break;
                            }

                            u(v);
                            _context2.next = 17;
                            break;

                          case 5:
                            if (!y) {
                              _context2.next = 17;
                              break;
                            }

                            y.self.publicKey = g;
                            H = X(w({}, y), {
                              requiredNamespaces: y.requiredNamespaces,
                              optionalNamespaces: y.optionalNamespaces
                            });
                            _context2.next = 10;
                            return _this.client.session.set(y.topic, H);

                          case 10:
                            _context2.next = 12;
                            return _this.setExpiry(y.topic, y.expiry);

                          case 12:
                            _context2.t0 = l;

                            if (!_context2.t0) {
                              _context2.next = 16;
                              break;
                            }

                            _context2.next = 16;
                            return _this.client.core.pairing.updateMetadata({
                              topic: l,
                              metadata: y.peer.metadata
                            });

                          case 16:
                            V(H);

                          case 17:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }()), !l)) {
                  _context3.next = 24;
                  break;
                }

                _c = c("NO_MATCHING_KEY", "connect() pairing topic: ".concat(l)), _v = _c.message;
                throw new Error(_v);

              case 24:
                _context3.next = 26;
                return _this.sendRequest(l, "wc_sessionPropose", f);

              case 26:
                L = _context3.sent;
                ce = _(m);
                _context3.next = 30;
                return _this.setProposal(L, w({
                  id: L,
                  expiry: ce
                }, f));

              case 30:
                return _context3.abrupt("return", {
                  uri: h,
                  approval: M
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.pair = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.isInitialized();

                _context4.next = 3;
                return _this.client.core.pairing.pair(e);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(), _this.approve = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
        var s, t, i, n, a, o, l, h, I, g, f, u, V, M;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this.isInitialized();

                _context5.next = 3;
                return _this.isValidApprove(e);

              case 3:
                s = e.id, t = e.relayProtocol, i = e.namespaces, n = e.sessionProperties, a = _this.client.proposal.get(s);
                o = a.pairingTopic, l = a.proposer, h = a.requiredNamespaces, I = a.optionalNamespaces;
                o = o || "", K(h) || (h = Ie(i, "approve()"));
                _context5.next = 8;
                return _this.client.core.crypto.generateKeyPair();

              case 8:
                g = _context5.sent;
                f = l.publicKey;
                _context5.next = 12;
                return _this.client.core.crypto.generateSharedKey(g, f);

              case 12:
                u = _context5.sent;
                _context5.t0 = o && s;

                if (!_context5.t0) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 17;
                return _this.client.core.pairing.updateMetadata({
                  topic: o,
                  metadata: l.metadata
                });

              case 17:
                _context5.next = 19;
                return _this.sendResult(s, o, {
                  relay: {
                    protocol: t !== null && t !== void 0 ? t : "irn"
                  },
                  responderPublicKey: g
                });

              case 19:
                _context5.next = 21;
                return _this.client.proposal.delete(s, E("USER_DISCONNECTED"));

              case 21:
                _context5.next = 23;
                return _this.client.core.pairing.activate({
                  topic: o
                });

              case 23:
                V = w({
                  relay: {
                    protocol: t !== null && t !== void 0 ? t : "irn"
                  },
                  namespaces: i,
                  requiredNamespaces: h,
                  optionalNamespaces: I,
                  pairingTopic: o,
                  controller: {
                    publicKey: g,
                    metadata: _this.client.metadata
                  },
                  expiry: _(A)
                }, n && {
                  sessionProperties: n
                });
                _context5.next = 26;
                return _this.client.core.relayer.subscribe(u);

              case 26:
                _context5.next = 28;
                return _this.sendRequest(u, "wc_sessionSettle", V);

              case 28:
                M = X(w({}, V), {
                  topic: u,
                  pairingTopic: o,
                  acknowledged: !1,
                  self: V.controller,
                  peer: {
                    publicKey: l.publicKey,
                    metadata: l.metadata
                  },
                  controller: g
                });
                _context5.next = 31;
                return _this.client.session.set(u, M);

              case 31:
                _context5.next = 33;
                return _this.setExpiry(u, _(A));

              case 33:
                return _context5.abrupt("return", {
                  topic: u,
                  acknowledged: function acknowledged() {
                    return new Promise(function (L) {
                      return L(_this.client.session.get(u));
                    });
                  }
                });

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }(), _this.reject = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
        var s, t, _this$client$proposal, i;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this.isInitialized();

                _context6.next = 3;
                return _this.isValidReject(e);

              case 3:
                s = e.id, t = e.reason, _this$client$proposal = _this.client.proposal.get(s), i = _this$client$proposal.pairingTopic;
                _context6.t0 = i;

                if (!_context6.t0) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 8;
                return _this.sendError(s, i, t);

              case 8:
                _context6.next = 10;
                return _this.client.proposal.delete(s, E("USER_DISCONNECTED"));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }(), _this.update = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
        var s, t, i, _T2, n, a, o;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this.isInitialized();

                _context7.next = 3;
                return _this.isValidUpdate(e);

              case 3:
                s = e.topic;
                t = e.namespaces;
                _context7.next = 7;
                return _this.sendRequest(s, "wc_sessionUpdate", {
                  namespaces: t
                });

              case 7:
                i = _context7.sent;
                _T2 = T();
                n = _T2.done;
                a = _T2.resolve;
                o = _T2.reject;

                _this.events.once(p("session_update", i), function (_ref9) {
                  var l = _ref9.error;
                  l ? o(l) : a();
                });

                _context7.next = 15;
                return _this.client.session.update(s, {
                  namespaces: t
                });

              case 15:
                return _context7.abrupt("return", {
                  acknowledged: n
                });

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x6) {
        return _ref8.apply(this, arguments);
      };
    }(), _this.extend = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        var s, t, _T3, i, n, a;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this.isInitialized();

                _context8.next = 3;
                return _this.isValidExtend(e);

              case 3:
                s = e.topic;
                _context8.next = 6;
                return _this.sendRequest(s, "wc_sessionExtend", {});

              case 6:
                t = _context8.sent;
                _T3 = T();
                i = _T3.done;
                n = _T3.resolve;
                a = _T3.reject;

                _this.events.once(p("session_extend", t), function (_ref11) {
                  var o = _ref11.error;
                  o ? a(o) : n();
                });

                _context8.next = 14;
                return _this.setExpiry(s, _(A));

              case 14:
                return _context8.abrupt("return", {
                  acknowledged: i
                });

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x7) {
        return _ref10.apply(this, arguments);
      };
    }(), _this.request = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
        var s, t, i, n, a, _T4, o, l, h;

        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this.isInitialized();

                _context9.next = 3;
                return _this.isValidRequest(e);

              case 3:
                s = e.chainId;
                t = e.request;
                i = e.topic;
                n = e.expiry;
                _context9.next = 9;
                return _this.sendRequest(i, "wc_sessionRequest", {
                  request: t,
                  chainId: s
                }, n);

              case 9:
                a = _context9.sent;
                _T4 = T(n);
                o = _T4.done;
                l = _T4.resolve;
                h = _T4.reject;

                _this.events.once(p("session_request", a), function (_ref13) {
                  var I = _ref13.error,
                      g = _ref13.result;
                  I ? h(I) : l(g);
                });

                _this.client.events.emit("session_request_sent", {
                  topic: i,
                  request: t,
                  chainId: s,
                  id: a
                });

                _context9.next = 18;
                return o();

              case 18:
                return _context9.abrupt("return", _context9.sent);

              case 19:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x8) {
        return _ref12.apply(this, arguments);
      };
    }(), _this.respond = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
        var s, t, i;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this.isInitialized();

                _context10.next = 3;
                return _this.isValidRespond(e);

              case 3:
                s = e.topic, t = e.response, i = t.id;

                if (!R(t)) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 7;
                return _this.sendResult(i, s, t.result);

              case 7:
                _context10.next = 13;
                break;

              case 9:
                _context10.t0 = N(t);

                if (!_context10.t0) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 13;
                return _this.sendError(i, s, t.error);

              case 13:
                _this.deletePendingSessionRequest(e.response.id, {
                  message: "fulfilled",
                  code: 0
                });

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x9) {
        return _ref14.apply(this, arguments);
      };
    }(), _this.ping = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
        var s, t, _T5, i, n, a;

        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this.isInitialized();

                _context11.next = 3;
                return _this.isValidPing(e);

              case 3:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context11.next = 17;
                  break;
                }

                _context11.next = 7;
                return _this.sendRequest(s, "wc_sessionPing", {});

              case 7:
                t = _context11.sent;
                _T5 = T();
                i = _T5.done;
                n = _T5.resolve;
                a = _T5.reject;

                _this.events.once(p("session_ping", t), function (_ref16) {
                  var o = _ref16.error;
                  o ? a(o) : n();
                });

                _context11.next = 15;
                return i();

              case 15:
                _context11.next = 21;
                break;

              case 17:
                _context11.t0 = _this.client.core.pairing.pairings.keys.includes(s);

                if (!_context11.t0) {
                  _context11.next = 21;
                  break;
                }

                _context11.next = 21;
                return _this.client.core.pairing.ping({
                  topic: s
                });

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x10) {
        return _ref15.apply(this, arguments);
      };
    }(), _this.emit = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
        var s, t, i;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this.isInitialized();

                _context12.next = 3;
                return _this.isValidEmit(e);

              case 3:
                s = e.topic, t = e.event, i = e.chainId;
                _context12.next = 6;
                return _this.sendRequest(s, "wc_sessionEvent", {
                  event: t,
                  chainId: i
                });

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x11) {
        return _ref17.apply(this, arguments);
      };
    }(), _this.disconnect = /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(e) {
        var s;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this.isInitialized();

                _context13.next = 3;
                return _this.isValidDisconnect(e);

              case 3:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context13.next = 11;
                  break;
                }

                _context13.next = 7;
                return _this.sendRequest(s, "wc_sessionDelete", E("USER_DISCONNECTED"));

              case 7:
                _context13.next = 9;
                return _this.deleteSession(s);

              case 9:
                _context13.next = 13;
                break;

              case 11:
                _context13.next = 13;
                return _this.client.core.pairing.disconnect({
                  topic: s
                });

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x12) {
        return _ref18.apply(this, arguments);
      };
    }(), _this.find = function (e) {
      return _this.isInitialized(), _this.client.session.getAll().filter(function (s) {
        return _e(s, e);
      });
    }, _this.getPendingSessionRequests = function () {
      return _this.isInitialized(), _this.client.pendingRequest.getAll();
    }, _this.deleteSession = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(e, s) {
        var _this$client$session$, t;

        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this$client$session$ = _this.client.session.get(e), t = _this$client$session$.self;
                _context14.next = 3;
                return _this.client.core.relayer.unsubscribe(e);

              case 3:
                _context14.next = 5;
                return Promise.all([_this.client.session.delete(e, E("USER_DISCONNECTED")), _this.client.core.crypto.deleteKeyPair(t.publicKey), _this.client.core.crypto.deleteSymKey(e), s ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x13, _x14) {
        return _ref19.apply(this, arguments);
      };
    }(), _this.deleteProposal = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(e, s) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return Promise.all([_this.client.proposal.delete(e, E("USER_DISCONNECTED")), s ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x15, _x16) {
        return _ref20.apply(this, arguments);
      };
    }(), _this.deletePendingSessionRequest = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e, s) {
        var t,
            _args16 = arguments;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                t = _args16.length > 2 && _args16[2] !== undefined ? _args16[2] : !1;
                _context16.next = 3;
                return Promise.all([_this.client.pendingRequest.delete(e, s), t ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x17, _x18) {
        return _ref21.apply(this, arguments);
      };
    }(), _this.setExpiry = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(e, s) {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.t0 = _this.client.session.keys.includes(e);

                if (!_context17.t0) {
                  _context17.next = 4;
                  break;
                }

                _context17.next = 4;
                return _this.client.session.update(e, {
                  expiry: s
                });

              case 4:
                _this.client.core.expirer.set(e, s);

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x19, _x20) {
        return _ref22.apply(this, arguments);
      };
    }(), _this.setProposal = /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(e, s) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _this.client.proposal.set(e, s);

              case 2:
                _this.client.core.expirer.set(e, s.expiry);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x21, _x22) {
        return _ref23.apply(this, arguments);
      };
    }(), _this.setPendingSessionRequest = /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(e) {
        var s, t, i, n;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                s = O.wc_sessionRequest.req.ttl, t = e.id, i = e.topic, n = e.params;
                _context19.next = 3;
                return _this.client.pendingRequest.set(t, {
                  id: t,
                  topic: i,
                  params: n
                });

              case 3:
                s && _this.client.core.expirer.set(t, _(s));

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x23) {
        return _ref24.apply(this, arguments);
      };
    }(), _this.sendRequest = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(e, s, t, i) {
        var n, l, a, o;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                n = Me(s, t);

                if (!(Ee() && ne.includes(s))) {
                  _context20.next = 5;
                  break;
                }

                l = z(JSON.stringify(n));
                _context20.next = 5;
                return _this.client.core.verify.register({
                  attestationId: l
                });

              case 5:
                _context20.next = 7;
                return _this.client.core.crypto.encode(e, n);

              case 7:
                a = _context20.sent;
                o = O[s].req;
                return _context20.abrupt("return", (i && (o.ttl = i), _this.client.core.history.set(e, n), _this.client.core.relayer.publish(e, a, o), n.id));

              case 10:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x24, _x25, _x26, _x27) {
        return _ref25.apply(this, arguments);
      };
    }(), _this.sendResult = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(e, s, t) {
        var i, n, a, o;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                i = Ue(e, t);
                _context21.next = 3;
                return _this.client.core.crypto.encode(s, i);

              case 3:
                n = _context21.sent;
                _context21.next = 6;
                return _this.client.core.history.get(s, e);

              case 6:
                a = _context21.sent;
                o = O[a.request.method].res;

                _this.client.core.relayer.publish(s, n, o);

                _context21.next = 11;
                return _this.client.core.history.resolve(i);

              case 11:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x28, _x29, _x30) {
        return _ref26.apply(this, arguments);
      };
    }(), _this.sendError = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(e, s, t) {
        var i, n, a, o;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                i = Ke(e, t);
                _context22.next = 3;
                return _this.client.core.crypto.encode(s, i);

              case 3:
                n = _context22.sent;
                _context22.next = 6;
                return _this.client.core.history.get(s, e);

              case 6:
                a = _context22.sent;
                o = O[a.request.method].res;

                _this.client.core.relayer.publish(s, n, o);

                _context22.next = 11;
                return _this.client.core.history.resolve(i);

              case 11:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x31, _x32, _x33) {
        return _ref27.apply(this, arguments);
      };
    }(), _this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      var e, s;
      return _regeneratorRuntime().wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              e = [], s = [];

              _this.client.session.getAll().forEach(function (t) {
                P(t.expiry) && e.push(t.topic);
              });

              _this.client.proposal.getAll().forEach(function (t) {
                P(t.expiry) && s.push(t.id);
              });

              _context23.next = 5;
              return Promise.all([].concat(_toConsumableArray(e.map(function (t) {
                return _this.deleteSession(t);
              })), _toConsumableArray(s.map(function (t) {
                return _this.deleteProposal(t);
              }))));

            case 5:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    })), _this.onRelayEventRequest = function (e) {
      var s = e.topic,
          t = e.payload,
          i = t.method;

      switch (i) {
        case "wc_sessionPropose":
          return _this.onSessionProposeRequest(s, t);

        case "wc_sessionSettle":
          return _this.onSessionSettleRequest(s, t);

        case "wc_sessionUpdate":
          return _this.onSessionUpdateRequest(s, t);

        case "wc_sessionExtend":
          return _this.onSessionExtendRequest(s, t);

        case "wc_sessionPing":
          return _this.onSessionPingRequest(s, t);

        case "wc_sessionDelete":
          return _this.onSessionDeleteRequest(s, t);

        case "wc_sessionRequest":
          return _this.onSessionRequest(s, t);

        case "wc_sessionEvent":
          return _this.onSessionEventRequest(s, t);

        default:
          return _this.client.logger.info("Unsupported request method ".concat(i));
      }
    }, _this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
        var s, t, i;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                s = e.topic;
                t = e.payload;
                _context24.next = 4;
                return _this.client.core.history.get(s, t.id);

              case 4:
                i = _context24.sent.request.method;
                _context24.t0 = i;
                _context24.next = _context24.t0 === "wc_sessionPropose" ? 8 : _context24.t0 === "wc_sessionSettle" ? 9 : _context24.t0 === "wc_sessionUpdate" ? 10 : _context24.t0 === "wc_sessionExtend" ? 11 : _context24.t0 === "wc_sessionPing" ? 12 : _context24.t0 === "wc_sessionRequest" ? 13 : 14;
                break;

              case 8:
                return _context24.abrupt("return", _this.onSessionProposeResponse(s, t));

              case 9:
                return _context24.abrupt("return", _this.onSessionSettleResponse(s, t));

              case 10:
                return _context24.abrupt("return", _this.onSessionUpdateResponse(s, t));

              case 11:
                return _context24.abrupt("return", _this.onSessionExtendResponse(s, t));

              case 12:
                return _context24.abrupt("return", _this.onSessionPingResponse(s, t));

              case 13:
                return _context24.abrupt("return", _this.onSessionRequestResponse(s, t));

              case 14:
                return _context24.abrupt("return", _this.client.logger.info("Unsupported response method ".concat(i)));

              case 15:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      return function (_x34) {
        return _ref29.apply(this, arguments);
      };
    }(), _this.onSessionProposeRequest = /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(e, s) {
        var t, i, n, a, o, l;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                t = s.params, i = s.id;
                _context25.prev = 1;

                _this.isValidConnect(w({}, s.params));

                n = _(m), a = w({
                  id: i,
                  pairingTopic: e,
                  expiry: n
                }, t);
                _context25.next = 6;
                return _this.setProposal(i, a);

              case 6:
                o = z(JSON.stringify(s));
                _context25.next = 9;
                return _this.getVerifyContext(o, a.proposer.metadata);

              case 9:
                l = _context25.sent;

                _this.client.events.emit("session_proposal", {
                  id: i,
                  params: a,
                  context: l
                });

                _context25.next = 18;
                break;

              case 13:
                _context25.prev = 13;
                _context25.t0 = _context25["catch"](1);
                _context25.next = 17;
                return _this.sendError(i, e, _context25.t0);

              case 17:
                _this.client.logger.error(_context25.t0);

              case 18:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[1, 13]]);
      }));

      return function (_x35, _x36) {
        return _ref30.apply(this, arguments);
      };
    }(), _this.onSessionProposeResponse = /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(e, s) {
        var t, i, n, a, o, l, h;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                t = s.id;

                if (!R(s)) {
                  _context26.next = 22;
                  break;
                }

                i = s.result;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  result: i
                });

                n = _this.client.proposal.get(t);

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  proposal: n
                });

                a = n.proposer.publicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  selfPublicKey: a
                });

                o = i.responderPublicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  peerPublicKey: o
                });

                _context26.next = 12;
                return _this.client.core.crypto.generateSharedKey(a, o);

              case 12:
                l = _context26.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  sessionTopic: l
                });

                _context26.next = 16;
                return _this.client.core.relayer.subscribe(l);

              case 16:
                h = _context26.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  subscriptionId: h
                });

                _context26.next = 20;
                return _this.client.core.pairing.activate({
                  topic: e
                });

              case 20:
                _context26.next = 27;
                break;

              case 22:
                _context26.t0 = N(s);

                if (!_context26.t0) {
                  _context26.next = 27;
                  break;
                }

                _context26.next = 26;
                return _this.client.proposal.delete(t, E("USER_DISCONNECTED"));

              case 26:
                _this.events.emit(p("session_connect"), {
                  error: s.error
                });

              case 27:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      return function (_x37, _x38) {
        return _ref31.apply(this, arguments);
      };
    }(), _this.onSessionSettleRequest = /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(e, s) {
        var t, i, _s$params, n, a, o, l, h, I, g, f, u;

        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                t = s.id, i = s.params;
                _context27.prev = 1;

                _this.isValidSessionSettleRequest(i);

                _s$params = s.params, n = _s$params.relay, a = _s$params.controller, o = _s$params.expiry, l = _s$params.namespaces, h = _s$params.requiredNamespaces, I = _s$params.optionalNamespaces, g = _s$params.sessionProperties, f = _s$params.pairingTopic, u = w({
                  topic: e,
                  relay: n,
                  expiry: o,
                  namespaces: l,
                  acknowledged: !0,
                  pairingTopic: f,
                  requiredNamespaces: h,
                  optionalNamespaces: I,
                  controller: a.publicKey,
                  self: {
                    publicKey: "",
                    metadata: _this.client.metadata
                  },
                  peer: {
                    publicKey: a.publicKey,
                    metadata: a.metadata
                  }
                }, g && {
                  sessionProperties: g
                });
                _context27.next = 6;
                return _this.sendResult(s.id, e, !0);

              case 6:
                _this.events.emit(p("session_connect"), {
                  session: u
                });

                _context27.next = 14;
                break;

              case 9:
                _context27.prev = 9;
                _context27.t0 = _context27["catch"](1);
                _context27.next = 13;
                return _this.sendError(t, e, _context27.t0);

              case 13:
                _this.client.logger.error(_context27.t0);

              case 14:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[1, 9]]);
      }));

      return function (_x39, _x40) {
        return _ref32.apply(this, arguments);
      };
    }(), _this.onSessionSettleResponse = /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(e, s) {
        var t;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                t = s.id;

                if (!R(s)) {
                  _context28.next = 7;
                  break;
                }

                _context28.next = 4;
                return _this.client.session.update(e, {
                  acknowledged: !0
                });

              case 4:
                _this.events.emit(p("session_approve", t), {});

                _context28.next = 12;
                break;

              case 7:
                _context28.t0 = N(s);

                if (!_context28.t0) {
                  _context28.next = 12;
                  break;
                }

                _context28.next = 11;
                return _this.client.session.delete(e, E("USER_DISCONNECTED"));

              case 11:
                _this.events.emit(p("session_approve", t), {
                  error: s.error
                });

              case 12:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      return function (_x41, _x42) {
        return _ref33.apply(this, arguments);
      };
    }(), _this.onSessionUpdateRequest = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(e, s) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                t = s.params, i = s.id;
                _context29.prev = 1;

                _this.isValidUpdate(w({
                  topic: e
                }, t));

                _context29.next = 5;
                return _this.client.session.update(e, {
                  namespaces: t.namespaces
                });

              case 5:
                _context29.next = 7;
                return _this.sendResult(i, e, !0);

              case 7:
                _this.client.events.emit("session_update", {
                  id: i,
                  topic: e,
                  params: t
                });

                _context29.next = 15;
                break;

              case 10:
                _context29.prev = 10;
                _context29.t0 = _context29["catch"](1);
                _context29.next = 14;
                return _this.sendError(i, e, _context29.t0);

              case 14:
                _this.client.logger.error(_context29.t0);

              case 15:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, null, [[1, 10]]);
      }));

      return function (_x43, _x44) {
        return _ref34.apply(this, arguments);
      };
    }(), _this.onSessionUpdateResponse = function (e, s) {
      var t = s.id;
      R(s) ? _this.events.emit(p("session_update", t), {}) : N(s) && _this.events.emit(p("session_update", t), {
        error: s.error
      });
    }, _this.onSessionExtendRequest = /*#__PURE__*/function () {
      var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(e, s) {
        var t;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = s.id;
                _context30.prev = 1;

                _this.isValidExtend({
                  topic: e
                });

                _context30.next = 5;
                return _this.setExpiry(e, _(A));

              case 5:
                _context30.next = 7;
                return _this.sendResult(t, e, !0);

              case 7:
                _this.client.events.emit("session_extend", {
                  id: t,
                  topic: e
                });

                _context30.next = 15;
                break;

              case 10:
                _context30.prev = 10;
                _context30.t0 = _context30["catch"](1);
                _context30.next = 14;
                return _this.sendError(t, e, _context30.t0);

              case 14:
                _this.client.logger.error(_context30.t0);

              case 15:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[1, 10]]);
      }));

      return function (_x45, _x46) {
        return _ref35.apply(this, arguments);
      };
    }(), _this.onSessionExtendResponse = function (e, s) {
      var t = s.id;
      R(s) ? _this.events.emit(p("session_extend", t), {}) : N(s) && _this.events.emit(p("session_extend", t), {
        error: s.error
      });
    }, _this.onSessionPingRequest = /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(e, s) {
        var t;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                t = s.id;
                _context31.prev = 1;

                _this.isValidPing({
                  topic: e
                });

                _context31.next = 5;
                return _this.sendResult(t, e, !0);

              case 5:
                _this.client.events.emit("session_ping", {
                  id: t,
                  topic: e
                });

                _context31.next = 13;
                break;

              case 8:
                _context31.prev = 8;
                _context31.t0 = _context31["catch"](1);
                _context31.next = 12;
                return _this.sendError(t, e, _context31.t0);

              case 12:
                _this.client.logger.error(_context31.t0);

              case 13:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, null, [[1, 8]]);
      }));

      return function (_x47, _x48) {
        return _ref36.apply(this, arguments);
      };
    }(), _this.onSessionPingResponse = function (e, s) {
      var t = s.id;
      setTimeout(function () {
        R(s) ? _this.events.emit(p("session_ping", t), {}) : N(s) && _this.events.emit(p("session_ping", t), {
          error: s.error
        });
      }, 500);
    }, _this.onSessionDeleteRequest = /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(e, s) {
        var t;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                t = s.id;
                _context33.prev = 1;

                _this.isValidDisconnect({
                  topic: e,
                  reason: s.params
                });

                _context33.next = 5;
                return Promise.all([new Promise(function (i) {
                  _this.client.core.relayer.once(F.publish, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
                    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                      while (1) {
                        switch (_context32.prev = _context32.next) {
                          case 0:
                            _context32.t0 = i;
                            _context32.next = 3;
                            return _this.deleteSession(e);

                          case 3:
                            _context32.t1 = _context32.sent;
                            (0, _context32.t0)(_context32.t1);

                          case 5:
                          case "end":
                            return _context32.stop();
                        }
                      }
                    }, _callee32);
                  })));
                }), _this.sendResult(t, e, !0)]);

              case 5:
                _this.client.events.emit("session_delete", {
                  id: t,
                  topic: e
                });

                _context33.next = 13;
                break;

              case 8:
                _context33.prev = 8;
                _context33.t0 = _context33["catch"](1);
                _context33.next = 12;
                return _this.sendError(t, e, _context33.t0);

              case 12:
                _this.client.logger.error(_context33.t0);

              case 13:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, null, [[1, 8]]);
      }));

      return function (_x49, _x50) {
        return _ref37.apply(this, arguments);
      };
    }(), _this.onSessionRequest = /*#__PURE__*/function () {
      var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(e, s) {
        var t, i, n, a, o;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                t = s.id, i = s.params;
                _context34.prev = 1;

                _this.isValidRequest(w({
                  topic: e
                }, i));

                _context34.next = 5;
                return _this.setPendingSessionRequest({
                  id: t,
                  topic: e,
                  params: i
                });

              case 5:
                n = z(JSON.stringify(s));
                a = _this.client.session.get(e);
                _context34.next = 9;
                return _this.getVerifyContext(n, a.peer.metadata);

              case 9:
                o = _context34.sent;

                _this.client.events.emit("session_request", {
                  id: t,
                  topic: e,
                  params: i,
                  context: o
                });

                _context34.next = 18;
                break;

              case 13:
                _context34.prev = 13;
                _context34.t0 = _context34["catch"](1);
                _context34.next = 17;
                return _this.sendError(t, e, _context34.t0);

              case 17:
                _this.client.logger.error(_context34.t0);

              case 18:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, null, [[1, 13]]);
      }));

      return function (_x51, _x52) {
        return _ref39.apply(this, arguments);
      };
    }(), _this.onSessionRequestResponse = function (e, s) {
      var t = s.id;
      R(s) ? _this.events.emit(p("session_request", t), {
        result: s.result
      }) : N(s) && _this.events.emit(p("session_request", t), {
        error: s.error
      });
    }, _this.onSessionEventRequest = /*#__PURE__*/function () {
      var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(e, s) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                t = s.id, i = s.params;
                _context35.prev = 1;
                _this.isValidEmit(w({
                  topic: e
                }, i)), _this.client.events.emit("session_event", {
                  id: t,
                  topic: e,
                  params: i
                });
                _context35.next = 10;
                break;

              case 5:
                _context35.prev = 5;
                _context35.t0 = _context35["catch"](1);
                _context35.next = 9;
                return _this.sendError(t, e, _context35.t0);

              case 9:
                _this.client.logger.error(_context35.t0);

              case 10:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[1, 5]]);
      }));

      return function (_x53, _x54) {
        return _ref40.apply(this, arguments);
      };
    }(), _this.isValidConnect = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(e) {
        var _c2, o, s, t, i, n, a, _c3, _o;

        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                if (S(e)) {
                  _context36.next = 3;
                  break;
                }

                _c2 = c("MISSING_OR_INVALID", "connect() params: ".concat(JSON.stringify(e))), o = _c2.message;
                throw new Error(o);

              case 3:
                s = e.pairingTopic, t = e.requiredNamespaces, i = e.optionalNamespaces, n = e.sessionProperties, a = e.relays;
                _context36.t0 = x(s);

                if (_context36.t0) {
                  _context36.next = 8;
                  break;
                }

                _context36.next = 8;
                return _this.isValidPairingTopic(s);

              case 8:
                if (Re(a, !0)) {
                  _context36.next = 11;
                  break;
                }

                _c3 = c("MISSING_OR_INVALID", "connect() relays: ".concat(a)), _o = _c3.message;
                throw new Error(_o);

              case 11:
                !x(t) && K(t) !== 0 && _this.validateNamespaces(t, "requiredNamespaces"), !x(i) && K(i) !== 0 && _this.validateNamespaces(i, "optionalNamespaces"), x(n) || _this.validateSessionProps(n, "sessionProperties");

              case 12:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36);
      }));

      return function (_x55) {
        return _ref41.apply(this, arguments);
      };
    }(), _this.validateNamespaces = function (e, s) {
      var t = Ne(e, "connect()", s);
      if (t) throw new Error(t.message);
    }, _this.isValidApprove = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(e) {
        var s, t, i, n, a, o, l, _c4, h;

        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (S(e)) {
                  _context37.next = 2;
                  break;
                }

                throw new Error(c("MISSING_OR_INVALID", "approve() params: ".concat(e)).message);

              case 2:
                s = e.id, t = e.namespaces, i = e.relayProtocol, n = e.sessionProperties;
                _context37.next = 5;
                return _this.isValidProposalId(s);

              case 5:
                a = _this.client.proposal.get(s), o = Y(t, "approve()");

                if (!o) {
                  _context37.next = 8;
                  break;
                }

                throw new Error(o.message);

              case 8:
                l = B(a.requiredNamespaces, t, "approve()");

                if (!l) {
                  _context37.next = 11;
                  break;
                }

                throw new Error(l.message);

              case 11:
                if (D(i, !0)) {
                  _context37.next = 14;
                  break;
                }

                _c4 = c("MISSING_OR_INVALID", "approve() relayProtocol: ".concat(i)), h = _c4.message;
                throw new Error(h);

              case 14:
                x(n) || _this.validateSessionProps(n, "sessionProperties");

              case 15:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      return function (_x56) {
        return _ref42.apply(this, arguments);
      };
    }(), _this.isValidReject = /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(e) {
        var _c5, i, s, t, _c6, _i;

        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (S(e)) {
                  _context38.next = 3;
                  break;
                }

                _c5 = c("MISSING_OR_INVALID", "reject() params: ".concat(e)), i = _c5.message;
                throw new Error(i);

              case 3:
                s = e.id, t = e.reason;
                _context38.next = 6;
                return _this.isValidProposalId(s);

              case 6:
                if (fe(t)) {
                  _context38.next = 9;
                  break;
                }

                _c6 = c("MISSING_OR_INVALID", "reject() reason: ".concat(JSON.stringify(t))), _i = _c6.message;
                throw new Error(_i);

              case 9:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      return function (_x57) {
        return _ref43.apply(this, arguments);
      };
    }(), _this.isValidSessionSettleRequest = function (e) {
      if (!S(e)) {
        var _c7 = c("MISSING_OR_INVALID", "onSessionSettleRequest() params: ".concat(e)),
            l = _c7.message;

        throw new Error(l);
      }

      var s = e.relay,
          t = e.controller,
          i = e.namespaces,
          n = e.expiry;

      if (!ve(s)) {
        var _c8 = c("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string"),
            _l = _c8.message;

        throw new Error(_l);
      }

      var a = Pe(t, "onSessionSettleRequest()");
      if (a) throw new Error(a.message);
      var o = Y(i, "onSessionSettleRequest()");
      if (o) throw new Error(o.message);

      if (P(n)) {
        var _c9 = c("EXPIRED", "onSessionSettleRequest()"),
            _l2 = _c9.message;

        throw new Error(_l2);
      }
    }, _this.isValidUpdate = /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(e) {
        var _c10, o, s, t, i, n, a;

        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (S(e)) {
                  _context39.next = 3;
                  break;
                }

                _c10 = c("MISSING_OR_INVALID", "update() params: ".concat(e)), o = _c10.message;
                throw new Error(o);

              case 3:
                s = e.topic, t = e.namespaces;
                _context39.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                i = _this.client.session.get(s), n = Y(t, "update()");

                if (!n) {
                  _context39.next = 9;
                  break;
                }

                throw new Error(n.message);

              case 9:
                a = B(i.requiredNamespaces, t, "update()");

                if (!a) {
                  _context39.next = 12;
                  break;
                }

                throw new Error(a.message);

              case 12:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));

      return function (_x58) {
        return _ref44.apply(this, arguments);
      };
    }(), _this.isValidExtend = /*#__PURE__*/function () {
      var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(e) {
        var _c11, t, s;

        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (S(e)) {
                  _context40.next = 3;
                  break;
                }

                _c11 = c("MISSING_OR_INVALID", "extend() params: ".concat(e)), t = _c11.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context40.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));

      return function (_x59) {
        return _ref45.apply(this, arguments);
      };
    }(), _this.isValidRequest = /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(e) {
        var _c12, o, s, t, i, n, _this$client$session$2, a, _c13, _o2, _c14, _o3, _c15, _o4, _c16, _o5;

        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (S(e)) {
                  _context41.next = 3;
                  break;
                }

                _c12 = c("MISSING_OR_INVALID", "request() params: ".concat(e)), o = _c12.message;
                throw new Error(o);

              case 3:
                s = e.topic, t = e.request, i = e.chainId, n = e.expiry;
                _context41.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$2 = _this.client.session.get(s), a = _this$client$session$2.namespaces;

                if (Q(a, i)) {
                  _context41.next = 10;
                  break;
                }

                _c13 = c("MISSING_OR_INVALID", "request() chainId: ".concat(i)), _o2 = _c13.message;
                throw new Error(_o2);

              case 10:
                if (qe(t)) {
                  _context41.next = 13;
                  break;
                }

                _c14 = c("MISSING_OR_INVALID", "request() ".concat(JSON.stringify(t))), _o3 = _c14.message;
                throw new Error(_o3);

              case 13:
                if (Oe(a, i, t.method)) {
                  _context41.next = 16;
                  break;
                }

                _c15 = c("MISSING_OR_INVALID", "request() method: ".concat(t.method)), _o4 = _c15.message;
                throw new Error(_o4);

              case 16:
                if (!(n && !Ve(n, G))) {
                  _context41.next = 19;
                  break;
                }

                _c16 = c("MISSING_OR_INVALID", "request() expiry: ".concat(n, ". Expiry must be a number (in seconds) between ").concat(G.min, " and ").concat(G.max)), _o5 = _c16.message;
                throw new Error(_o5);

              case 19:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));

      return function (_x60) {
        return _ref46.apply(this, arguments);
      };
    }(), _this.isValidRespond = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(e) {
        var _c17, i, s, t, _c18, _i2;

        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (S(e)) {
                  _context42.next = 3;
                  break;
                }

                _c17 = c("MISSING_OR_INVALID", "respond() params: ".concat(e)), i = _c17.message;
                throw new Error(i);

              case 3:
                s = e.topic, t = e.response;
                _context42.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                if (Te(t)) {
                  _context42.next = 9;
                  break;
                }

                _c18 = c("MISSING_OR_INVALID", "respond() response: ".concat(JSON.stringify(t))), _i2 = _c18.message;
                throw new Error(_i2);

              case 9:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      return function (_x61) {
        return _ref47.apply(this, arguments);
      };
    }(), _this.isValidPing = /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(e) {
        var _c19, t, s;

        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if (S(e)) {
                  _context43.next = 3;
                  break;
                }

                _c19 = c("MISSING_OR_INVALID", "ping() params: ".concat(e)), t = _c19.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context43.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      return function (_x62) {
        return _ref48.apply(this, arguments);
      };
    }(), _this.isValidEmit = /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(e) {
        var _c20, a, s, t, i, _this$client$session$3, n, _c21, _a, _c22, _a2, _c23, _a3;

        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (S(e)) {
                  _context44.next = 3;
                  break;
                }

                _c20 = c("MISSING_OR_INVALID", "emit() params: ".concat(e)), a = _c20.message;
                throw new Error(a);

              case 3:
                s = e.topic, t = e.event, i = e.chainId;
                _context44.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$3 = _this.client.session.get(s), n = _this$client$session$3.namespaces;

                if (Q(n, i)) {
                  _context44.next = 10;
                  break;
                }

                _c21 = c("MISSING_OR_INVALID", "emit() chainId: ".concat(i)), _a = _c21.message;
                throw new Error(_a);

              case 10:
                if (xe(t)) {
                  _context44.next = 13;
                  break;
                }

                _c22 = c("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _a2 = _c22.message;
                throw new Error(_a2);

              case 13:
                if (De(n, i, t.name)) {
                  _context44.next = 16;
                  break;
                }

                _c23 = c("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _a3 = _c23.message;
                throw new Error(_a3);

              case 16:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      return function (_x63) {
        return _ref49.apply(this, arguments);
      };
    }(), _this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(e) {
        var _c24, t, s;

        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (S(e)) {
                  _context45.next = 3;
                  break;
                }

                _c24 = c("MISSING_OR_INVALID", "disconnect() params: ".concat(e)), t = _c24.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context45.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      return function (_x64) {
        return _ref50.apply(this, arguments);
      };
    }(), _this.getVerifyContext = /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(e, s) {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                t = {
                  verified: {
                    verifyUrl: s.verifyUrl || "",
                    validation: "UNKNOWN",
                    origin: s.url || ""
                  }
                };
                _context46.prev = 1;
                _context46.next = 4;
                return _this.client.core.verify.resolve({
                  attestationId: e,
                  verifyUrl: s.verifyUrl
                });

              case 4:
                i = _context46.sent;
                t.verified.origin = i, t.verified.validation = i === s.url ? "VALID" : "INVALID";
                _context46.next = 11;
                break;

              case 8:
                _context46.prev = 8;
                _context46.t0 = _context46["catch"](1);

                _this.client.logger.error(_context46.t0);

              case 11:
                return _context46.abrupt("return", (_this.client.logger.info("Verify context: ".concat(JSON.stringify(t))), t));

              case 12:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, null, [[1, 8]]);
      }));

      return function (_x65, _x66) {
        return _ref51.apply(this, arguments);
      };
    }(), _this.validateSessionProps = function (e, s) {
      Object.values(e).forEach(function (t) {
        if (!D(t, !1)) {
          var _c25 = c("MISSING_OR_INVALID", "".concat(s, " must be in Record<string, string> format. Received: ").concat(JSON.stringify(t))),
              i = _c25.message;

          throw new Error(i);
        }
      });
    };
    return _this;
  }

  _createClass(ss, [{
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c26 = c("NOT_INITIALIZED", this.name),
            r = _c26.message;

        throw new Error(r);
      }
    }
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this2 = this;

      this.client.core.relayer.on(F.message, /*#__PURE__*/function () {
        var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(r) {
          var e, s, t;
          return _regeneratorRuntime().wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  e = r.topic, s = r.message;

                  if (!_this2.ignoredPayloadTypes.includes(_this2.client.core.crypto.getPayloadType(s))) {
                    _context47.next = 3;
                    break;
                  }

                  return _context47.abrupt("return");

                case 3:
                  _context47.next = 5;
                  return _this2.client.core.crypto.decode(e, s);

                case 5:
                  t = _context47.sent;

                  if (!ze(t)) {
                    _context47.next = 10;
                    break;
                  }

                  _this2.client.core.history.set(e, t), _this2.onRelayEventRequest({
                    topic: e,
                    payload: t
                  });
                  _context47.next = 15;
                  break;

                case 10:
                  _context47.t0 = Ye(t);

                  if (!_context47.t0) {
                    _context47.next = 15;
                    break;
                  }

                  _context47.next = 14;
                  return _this2.client.core.history.resolve(t);

                case 14:
                  _this2.onRelayEventResponse({
                    topic: e,
                    payload: t
                  });

                case 15:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47);
        }));

        return function (_x67) {
          return _ref52.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this3 = this;

      this.client.core.expirer.on(pe.expired, /*#__PURE__*/function () {
        var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(r) {
          var _Ae, e, s;

          return _regeneratorRuntime().wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  _Ae = Ae(r.target), e = _Ae.topic, s = _Ae.id;

                  if (!(s && _this3.client.pendingRequest.keys.includes(s))) {
                    _context48.next = 5;
                    break;
                  }

                  _context48.next = 4;
                  return _this3.deletePendingSessionRequest(s, c("EXPIRED"), !0);

                case 4:
                  return _context48.abrupt("return", _context48.sent);

                case 5:
                  if (!e) {
                    _context48.next = 13;
                    break;
                  }

                  _context48.t0 = _this3.client.session.keys.includes(e);

                  if (!_context48.t0) {
                    _context48.next = 11;
                    break;
                  }

                  _context48.next = 10;
                  return _this3.deleteSession(e, !0);

                case 10:
                  _this3.client.events.emit("session_expire", {
                    topic: e
                  });

                case 11:
                  _context48.next = 18;
                  break;

                case 13:
                  _context48.t1 = s;

                  if (!_context48.t1) {
                    _context48.next = 18;
                    break;
                  }

                  _context48.next = 17;
                  return _this3.deleteProposal(s, !0);

                case 17:
                  _this3.client.events.emit("proposal_expire", {
                    id: s
                  });

                case 18:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48);
        }));

        return function (_x68) {
          return _ref53.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isValidPairingTopic",
    value: function isValidPairingTopic(r) {
      if (!D(r, !1)) {
        var _c27 = c("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(r)),
            e = _c27.message;

        throw new Error(e);
      }

      if (!this.client.core.pairing.pairings.keys.includes(r)) {
        var _c28 = c("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(r)),
            _e2 = _c28.message;

        throw new Error(_e2);
      }

      if (P(this.client.core.pairing.pairings.get(r).expiry)) {
        var _c29 = c("EXPIRED", "pairing topic: ".concat(r)),
            _e3 = _c29.message;

        throw new Error(_e3);
      }
    }
  }, {
    key: "isValidSessionTopic",
    value: function () {
      var _isValidSessionTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(r) {
        var _c30, e, _c31, _e4, _c32, _e5;

        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                if (D(r, !1)) {
                  _context49.next = 3;
                  break;
                }

                _c30 = c("MISSING_OR_INVALID", "session topic should be a string: ".concat(r)), e = _c30.message;
                throw new Error(e);

              case 3:
                if (this.client.session.keys.includes(r)) {
                  _context49.next = 6;
                  break;
                }

                _c31 = c("NO_MATCHING_KEY", "session topic doesn't exist: ".concat(r)), _e4 = _c31.message;
                throw new Error(_e4);

              case 6:
                if (!P(this.client.session.get(r).expiry)) {
                  _context49.next = 11;
                  break;
                }

                _context49.next = 9;
                return this.deleteSession(r);

              case 9:
                _c32 = c("EXPIRED", "session topic: ".concat(r)), _e5 = _c32.message;
                throw new Error(_e5);

              case 11:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function isValidSessionTopic(_x69) {
        return _isValidSessionTopic.apply(this, arguments);
      }

      return isValidSessionTopic;
    }()
  }, {
    key: "isValidSessionOrPairingTopic",
    value: function () {
      var _isValidSessionOrPairingTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(r) {
        var _c33, e, _c34, _e6;

        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if (!this.client.session.keys.includes(r)) {
                  _context50.next = 5;
                  break;
                }

                _context50.next = 3;
                return this.isValidSessionTopic(r);

              case 3:
                _context50.next = 16;
                break;

              case 5:
                if (!this.client.core.pairing.pairings.keys.includes(r)) {
                  _context50.next = 9;
                  break;
                }

                this.isValidPairingTopic(r);
                _context50.next = 16;
                break;

              case 9:
                if (!D(r, !1)) {
                  _context50.next = 14;
                  break;
                }

                _c33 = c("NO_MATCHING_KEY", "session or pairing topic doesn't exist: ".concat(r)), e = _c33.message;
                throw new Error(e);

              case 14:
                _c34 = c("MISSING_OR_INVALID", "session or pairing topic should be a string: ".concat(r)), _e6 = _c34.message;
                throw new Error(_e6);

              case 16:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function isValidSessionOrPairingTopic(_x70) {
        return _isValidSessionOrPairingTopic.apply(this, arguments);
      }

      return isValidSessionOrPairingTopic;
    }()
  }, {
    key: "isValidProposalId",
    value: function () {
      var _isValidProposalId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(r) {
        var _c35, e, _c36, _e7, _c37, _e8;

        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                if (Le(r)) {
                  _context51.next = 3;
                  break;
                }

                _c35 = c("MISSING_OR_INVALID", "proposal id should be a number: ".concat(r)), e = _c35.message;
                throw new Error(e);

              case 3:
                if (this.client.proposal.keys.includes(r)) {
                  _context51.next = 6;
                  break;
                }

                _c36 = c("NO_MATCHING_KEY", "proposal id doesn't exist: ".concat(r)), _e7 = _c36.message;
                throw new Error(_e7);

              case 6:
                if (!P(this.client.proposal.get(r).expiry)) {
                  _context51.next = 11;
                  break;
                }

                _context51.next = 9;
                return this.deleteProposal(r);

              case 9:
                _c37 = c("EXPIRED", "proposal id: ".concat(r)), _e8 = _c37.message;
                throw new Error(_e8);

              case 11:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function isValidProposalId(_x71) {
        return _isValidProposalId.apply(this, arguments);
      }

      return isValidProposalId;
    }()
  }]);

  return ss;
}(ue);

var ts = /*#__PURE__*/function (_U) {
  _inherits(ts, _U);

  var _super2 = _createSuper(ts);

  function ts(r, e) {
    var _this4;

    _classCallCheck(this, ts);

    _this4 = _super2.call(this, r, e, ee, b), _this4.core = r, _this4.logger = e;
    return _this4;
  }

  return _createClass(ts);
}(U);

var is = /*#__PURE__*/function (_U2) {
  _inherits(is, _U2);

  var _super3 = _createSuper(is);

  function is(r, e) {
    var _this5;

    _classCallCheck(this, is);

    _this5 = _super3.call(this, r, e, te, b), _this5.core = r, _this5.logger = e;
    return _this5;
  }

  return _createClass(is);
}(U);

var rs = /*#__PURE__*/function (_U3) {
  _inherits(rs, _U3);

  var _super4 = _createSuper(rs);

  function rs(r, e) {
    var _this6;

    _classCallCheck(this, rs);

    _this6 = _super4.call(this, r, e, re, b, function (s) {
      return s.id;
    }), _this6.core = r, _this6.logger = e;
    return _this6;
  }

  return _createClass(rs);
}(U);

var $ = /*#__PURE__*/function (_ye) {
  _inherits($, _ye);

  var _super5 = _createSuper($);

  function $(r) {
    var _this7;

    _classCallCheck(this, $);

    _this7 = _super5.call(this, r), _this7.protocol = j, _this7.version = k, _this7.name = C.name, _this7.events = new Ge(), _this7.on = function (s, t) {
      return _this7.events.on(s, t);
    }, _this7.once = function (s, t) {
      return _this7.events.once(s, t);
    }, _this7.off = function (s, t) {
      return _this7.events.off(s, t);
    }, _this7.removeListener = function (s, t) {
      return _this7.events.removeListener(s, t);
    }, _this7.removeAllListeners = function (s) {
      return _this7.events.removeAllListeners(s);
    }, _this7.connect = /*#__PURE__*/function () {
      var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(s) {
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.prev = 0;
                _context52.next = 3;
                return _this7.engine.connect(s);

              case 3:
                return _context52.abrupt("return", _context52.sent);

              case 6:
                _context52.prev = 6;
                _context52.t0 = _context52["catch"](0);
                throw _this7.logger.error(_context52.t0.message), _context52.t0;

              case 9:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, null, [[0, 6]]);
      }));

      return function (_x72) {
        return _ref54.apply(this, arguments);
      };
    }(), _this7.pair = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(s) {
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.prev = 0;
                _context53.next = 3;
                return _this7.engine.pair(s);

              case 3:
                return _context53.abrupt("return", _context53.sent);

              case 6:
                _context53.prev = 6;
                _context53.t0 = _context53["catch"](0);
                throw _this7.logger.error(_context53.t0.message), _context53.t0;

              case 9:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, null, [[0, 6]]);
      }));

      return function (_x73) {
        return _ref55.apply(this, arguments);
      };
    }(), _this7.approve = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(s) {
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.prev = 0;
                _context54.next = 3;
                return _this7.engine.approve(s);

              case 3:
                return _context54.abrupt("return", _context54.sent);

              case 6:
                _context54.prev = 6;
                _context54.t0 = _context54["catch"](0);
                throw _this7.logger.error(_context54.t0.message), _context54.t0;

              case 9:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, null, [[0, 6]]);
      }));

      return function (_x74) {
        return _ref56.apply(this, arguments);
      };
    }(), _this7.reject = /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(s) {
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.prev = 0;
                _context55.next = 3;
                return _this7.engine.reject(s);

              case 3:
                return _context55.abrupt("return", _context55.sent);

              case 6:
                _context55.prev = 6;
                _context55.t0 = _context55["catch"](0);
                throw _this7.logger.error(_context55.t0.message), _context55.t0;

              case 9:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, null, [[0, 6]]);
      }));

      return function (_x75) {
        return _ref57.apply(this, arguments);
      };
    }(), _this7.update = /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(s) {
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.prev = 0;
                _context56.next = 3;
                return _this7.engine.update(s);

              case 3:
                return _context56.abrupt("return", _context56.sent);

              case 6:
                _context56.prev = 6;
                _context56.t0 = _context56["catch"](0);
                throw _this7.logger.error(_context56.t0.message), _context56.t0;

              case 9:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, null, [[0, 6]]);
      }));

      return function (_x76) {
        return _ref58.apply(this, arguments);
      };
    }(), _this7.extend = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57(s) {
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.prev = 0;
                _context57.next = 3;
                return _this7.engine.extend(s);

              case 3:
                return _context57.abrupt("return", _context57.sent);

              case 6:
                _context57.prev = 6;
                _context57.t0 = _context57["catch"](0);
                throw _this7.logger.error(_context57.t0.message), _context57.t0;

              case 9:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, null, [[0, 6]]);
      }));

      return function (_x77) {
        return _ref59.apply(this, arguments);
      };
    }(), _this7.request = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58(s) {
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.prev = 0;
                _context58.next = 3;
                return _this7.engine.request(s);

              case 3:
                return _context58.abrupt("return", _context58.sent);

              case 6:
                _context58.prev = 6;
                _context58.t0 = _context58["catch"](0);
                throw _this7.logger.error(_context58.t0.message), _context58.t0;

              case 9:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, null, [[0, 6]]);
      }));

      return function (_x78) {
        return _ref60.apply(this, arguments);
      };
    }(), _this7.respond = /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59(s) {
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.prev = 0;
                _context59.next = 3;
                return _this7.engine.respond(s);

              case 3:
                return _context59.abrupt("return", _context59.sent);

              case 6:
                _context59.prev = 6;
                _context59.t0 = _context59["catch"](0);
                throw _this7.logger.error(_context59.t0.message), _context59.t0;

              case 9:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, null, [[0, 6]]);
      }));

      return function (_x79) {
        return _ref61.apply(this, arguments);
      };
    }(), _this7.ping = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(s) {
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.prev = 0;
                _context60.next = 3;
                return _this7.engine.ping(s);

              case 3:
                return _context60.abrupt("return", _context60.sent);

              case 6:
                _context60.prev = 6;
                _context60.t0 = _context60["catch"](0);
                throw _this7.logger.error(_context60.t0.message), _context60.t0;

              case 9:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, null, [[0, 6]]);
      }));

      return function (_x80) {
        return _ref62.apply(this, arguments);
      };
    }(), _this7.emit = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(s) {
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;
                _context61.next = 3;
                return _this7.engine.emit(s);

              case 3:
                return _context61.abrupt("return", _context61.sent);

              case 6:
                _context61.prev = 6;
                _context61.t0 = _context61["catch"](0);
                throw _this7.logger.error(_context61.t0.message), _context61.t0;

              case 9:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, null, [[0, 6]]);
      }));

      return function (_x81) {
        return _ref63.apply(this, arguments);
      };
    }(), _this7.disconnect = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(s) {
        return _regeneratorRuntime().wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.prev = 0;
                _context62.next = 3;
                return _this7.engine.disconnect(s);

              case 3:
                return _context62.abrupt("return", _context62.sent);

              case 6:
                _context62.prev = 6;
                _context62.t0 = _context62["catch"](0);
                throw _this7.logger.error(_context62.t0.message), _context62.t0;

              case 9:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, null, [[0, 6]]);
      }));

      return function (_x82) {
        return _ref64.apply(this, arguments);
      };
    }(), _this7.find = function (s) {
      try {
        return _this7.engine.find(s);
      } catch (t) {
        throw _this7.logger.error(t.message), t;
      }
    }, _this7.getPendingSessionRequests = function () {
      try {
        return _this7.engine.getPendingSessionRequests();
      } catch (s) {
        throw _this7.logger.error(s.message), s;
      }
    }, _this7.name = (r === null || r === void 0 ? void 0 : r.name) || C.name, _this7.metadata = (r === null || r === void 0 ? void 0 : r.metadata) || be();
    var e = typeof (r === null || r === void 0 ? void 0 : r.logger) < "u" && typeof (r === null || r === void 0 ? void 0 : r.logger) != "string" ? r.logger : de(ge({
      level: (r === null || r === void 0 ? void 0 : r.logger) || C.logger
    }));
    _this7.core = (r === null || r === void 0 ? void 0 : r.core) || new he(r), _this7.logger = me(e, _this7.name), _this7.session = new is(_this7.core, _this7.logger), _this7.proposal = new ts(_this7.core, _this7.logger), _this7.pendingRequest = new rs(_this7.core, _this7.logger), _this7.engine = new ss(_assertThisInitialized(_this7));
    return _this7;
  }

  _createClass($, [{
    key: "context",
    get: function get() {
      return we(this.logger);
    }
  }, {
    key: "pairing",
    get: function get() {
      return this.core.pairing.pairings;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                this.logger.trace("Initialized");
                _context63.prev = 1;
                _context63.next = 4;
                return this.core.start();

              case 4:
                _context63.next = 6;
                return this.session.init();

              case 6:
                _context63.next = 8;
                return this.proposal.init();

              case 8:
                _context63.next = 10;
                return this.pendingRequest.init();

              case 10:
                _context63.next = 12;
                return this.engine.init();

              case 12:
                this.core.verify.init({
                  verifyUrl: this.metadata.verifyUrl
                });
                this.logger.info("SignClient Initialization Success");
                _context63.next = 19;
                break;

              case 16:
                _context63.prev = 16;
                _context63.t0 = _context63["catch"](1);
                throw this.logger.info("SignClient Initialization Failure"), this.logger.error(_context63.t0.message), _context63.t0;

              case 19:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this, [[1, 16]]);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64(r) {
        var e;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                e = new $(r);
                _context64.next = 3;
                return e.initialize();

              case 3:
                return _context64.abrupt("return", e);

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64);
      }));

      function init(_x83) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return $;
}(ye);

var ns = $;
export { ie as ENGINE_CONTEXT, O as ENGINE_RPC_OPTS, Xe as HISTORY_CONTEXT, Je as HISTORY_EVENTS, He as HISTORY_STORAGE_VERSION, ne as METHODS_TO_VERIFY, ee as PROPOSAL_CONTEXT, Fe as PROPOSAL_EXPIRY, se as PROPOSAL_EXPIRY_MESSAGE, re as REQUEST_CONTEXT, te as SESSION_CONTEXT, A as SESSION_EXPIRY, G as SESSION_REQUEST_EXPIRY_BOUNDARIES, J as SIGN_CLIENT_CONTEXT, C as SIGN_CLIENT_DEFAULT, je as SIGN_CLIENT_EVENTS, j as SIGN_CLIENT_PROTOCOL, ke as SIGN_CLIENT_STORAGE_OPTIONS, b as SIGN_CLIENT_STORAGE_PREFIX, k as SIGN_CLIENT_VERSION, ns as SignClient, $ as default };